import { render } from "./GetStarted.vue?vue&type=template&id=0a4d9aa4"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
script.render = render

export default script